import { useEffect, useRef } from "react";

// Adds "is-visible" class to elements with class "reveal" when scrolled into view.
export const useScrollReveal = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const els = document.querySelectorAll(".reveal:not(.is-visible)");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  });

  return containerRef;
};
